import React, { useState, useEffect } from 'react';
import { hesaplaLupamatKodu } from '../utils/lupamatHelper';

const LupamatKodUretici = () => {
  const [ekranKodu, setEkranKodu] = useState('');
  const [islemTuru, setIslemTuru] = useState('lcs500');
  const [geriKod, setGeriKod] = useState('');

  // Ekran kodu veya işlem türü değiştiğinde anlık hesaplama yap
  useEffect(() => {
    if (ekranKodu) {
      const sonuc = hesaplaLupamatKodu(ekranKodu, islemTuru);
      setGeriKod(sonuc);
    } else {
      setGeriKod('');
    }
  }, [ekranKodu, islemTuru]);

  const styles = {
    container: {
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      padding: '40px',
      backgroundColor: '#f5f5f7',
      boxSizing: 'border-box'
    },
    card: {
      width: '100%',
      maxWidth: '600px',
      background: '#ffffff',
      borderRadius: '20px',
      padding: '40px',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.05)'
    },
    title: {
      fontSize: '28px',
      fontWeight: '600',
      color: '#1d1d1f',
      margin: '0 0 8px 0',
      textAlign: 'left'
    },
    subtitle: {
      fontSize: '16px',
      color: '#86868b',
      margin: '0 0 32px 0',
      textAlign: 'left'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#1d1d1f'
    },
    input: {
      width: '100%',
      padding: '16px',
      fontSize: '16px',
      border: '1px solid #d2d2d7',
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      color: '#1d1d1f',
      outline: 'none',
      boxSizing: 'border-box',
      transition: 'all 0.2s ease'
    },
    resultGroup: {
      marginTop: '16px',
      paddingTop: '24px',
      borderTop: '1px solid #e5e5ea',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    resultDisplay: {
      fontSize: '48px',
      fontWeight: '700',
      color: '#0071e3',
      letterSpacing: '2px',
      textAlign: 'left'
    },
    copyBtn: {
      alignSelf: 'flex-start',
      padding: '10px 20px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#ffffff',
      backgroundColor: '#0071e3',
      border: 'none',
      borderRadius: '980px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Lupamat Kod Üretici</h1>
        <p style={styles.subtitle}>V2028 / V1028 Altı Parametre ve Bakım Sıfırlama</p>

        <div style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>İşlem Türü</label>
            <select 
              value={islemTuru} 
              onChange={(e) => setIslemTuru(e.target.value)}
              style={styles.input}
            >
              <option value="lcs500">V2028 / V1028 Altı LCS500 Parametre</option>
              <option value="bakim">V2028 / V1028 Altı Bakım Sıfırlama</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Ekran Kodu</label>
            <input 
              type="number" 
              value={ekranKodu} 
              onChange={(e) => setEkranKodu(e.target.value)}
              placeholder="Örn: 7020"
              style={styles.input}
              min="0"
            />
          </div>

          <div style={styles.resultGroup}>
            <label style={styles.label}>Üretilen Geri Kod</label>
            <div style={styles.resultDisplay}>
              {geriKod || '---'}
            </div>
            {geriKod && (
              <button 
                style={styles.copyBtn}
                onClick={() => {
                  navigator.clipboard.writeText(geriKod);
                  alert('Kod kopyalandı!');
                }}
              >
                Kopyala
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LupamatKodUretici;